import './Logo.css'

function Logo() {
  return (
    <section className="ko-logo">
      <div className="logo"></div>
    </section>
  )
}

export default Logo
